import Constants from '../constants/DevAuthConstants';
import DevAuthRemoting from '../../remoting/DevAuthRemoting';
import StatusCodes from '../../model/StatusCodes';

/**
 *
 * @param {*} type - type constant (string)
 * @param {*} data - object, list or string
 */
function dispatchToReducer (type, data) {
  return {
    type: type,
    data: data,
  };
}

/**
 * getSessionToken called on client getting session token and saving it to cookie
 */
export function getSessionToken () {
  return dispatch => {
    dispatch(dispatchToReducer(Constants.DEV_AUTH_REQUEST));
    DevAuthRemoting.getSessionToken()
      .then(response => {
        if (response && response.status === StatusCodes.UNKNOWN_ERROR) {
          console.error('Error occured: ', response.message);
          return dispatch(dispatchToReducer(Constants.DEV_AUTH_FAILURE, response));
        }
        if (response && response.status === StatusCodes.OK) {
          return dispatch(dispatchToReducer(Constants.DEV_AUTH_SUCCESS, response.data));
        }
      })
      .catch(error => {
        console.error('Error occured: ', error);
        return dispatch(dispatchToReducer(Constants.DEV_AUTH_FAILURE, error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/DevAuthActions.js